import type { ReactNode } from 'react';

export function Section({ title, children }: { title: string; children: ReactNode }) {
  return (
    <section className="mb-8 sm:mb-10">
      <h2 className="mp-display text-xl sm:text-2xl text-tarot-gold mb-3 sm:mb-4">{title}</h2>
      {children}
    </section>
  );
}

export function Loading({ text }: { text: string }) {
  return (
    <div className="text-center py-16 text-tarot-muted">
      <div className="inline-block w-6 h-6 rounded-full border-2 border-tarot-purple border-t-transparent animate-spin" />
      <p className="mt-4">{text}</p>
    </div>
  );
}
